import { useEffect, useRef } from "react";

/**
 * Gera as partículas de fumaça do estado apagado.
 * @param {object} styles  - o objeto do CSS Module (precisa ter .sp)
 * @param {boolean} active - true enquanto o fogo está apagado (sem acender/lit)
 * @returns ref para o container .smk
 */
export default function useFireSmoke(styles, active) {
  const ref = useRef(null);

  useEffect(() => {
    if (!active) return;
    if (document.documentElement.classList.contains("platform-android") || /Android/i.test(navigator.userAgent)) return;
    const smk = ref.current;
    if (!smk) return;

    const spawn = () => {
      const p = document.createElement("span");
      p.className = styles.sp;
      const sz = 3 + Math.random() * 9;
      p.style.cssText =
        `left:${28 + Math.random() * 44}%;` +
        `width:${sz}px;height:${sz}px;` +
        `--d:${(1.4 + Math.random() * 1.6).toFixed(2)}s;` +
        `--x:${((Math.random() - 0.5) * 32).toFixed(1)}px`;
      smk.appendChild(p);
      setTimeout(() => p.remove(), 3200);
    };

    const timer = setInterval(spawn, 360);
    spawn();
    spawn();
    return () => clearInterval(timer);
  }, [active, styles]);

  return ref;
}
